function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgSeguranca24 = function SvgSeguranca24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M10.848 19.129h4.67a.5.5 0 110 1H9.723a.5.5 0 01-.371-.835l3.7-4.102a7.876 7.876 0 00.723-.844c.26-.354.46-.696.574-1.003.07-.186.104-.35.104-.494.012-1.477-.75-2.157-2.115-2.157-1.158 0-2.115.979-2.115 2.16a.5.5 0 11-1 0c0-1.728 1.4-3.16 3.115-3.16 1.894 0 3.132 1.103 3.115 3.16 0 .27-.059.55-.166.84-.151.406-.396.824-.708 1.248a8.864 8.864 0 01-.807.943l-2.925 3.244zm10.359-8.452v6.315h.948a.5.5 0 110 1h-.948v1.92a.5.5 0 01-1 0v-1.92H16a.5.5 0 01-.411-.784l4.706-6.815a.5.5 0 01.912.284zm-4.254 6.315h3.254v-4.71l-3.254 4.71zM15.803.54a.5.5 0 01.394 0 38.507 38.507 0 001.357.53c1.086.4 2.297.802 3.598 1.176 2.993.86 6.003 1.449 8.881 1.641a.5.5 0 01.467.5V15.01c0 4.986-2.636 9.599-6.928 12.12l-7.319 4.3a.5.5 0 01-.506 0l-7.319-4.3A14.054 14.054 0 011.5 15.01V4.387a.5.5 0 01.467-.499c2.878-.192 5.888-.78 8.88-1.641a51.893 51.893 0 003.6-1.176 38.507 38.507 0 001.356-.53zm.197 1l-.175.071c-.298.12-.644.254-1.033.397a52.888 52.888 0 01-3.668 1.2C8.23 4.04 5.314 4.623 2.5 4.851v10.16c0 4.631 2.449 8.915 6.435 11.257L16 30.42l7.065-4.151A13.054 13.054 0 0029.5 15.01V4.851c-2.813-.227-5.729-.81-8.624-1.643a52.888 52.888 0 01-3.668-1.199A39.501 39.501 0 0116 1.542z"
  }));
};

SvgSeguranca24.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgSeguranca24.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgSeguranca24;